import {
    ChangeDetectionStrategy, Component, OnDestroy,
    OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppConfigService } from './config/app-config.service';
import { SplashScreenComponent } from './_metronic/partials/layout/splash-screen/splash-screen.component';
import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { ChatbotComponent } from './_partials/chatbot/chatbot.component';
import { FooterComponent } from './_partials/footer/footer.component';
import { HeaderComponent } from './_partials/header/header.component';

declare let gtag: Function;
@Component({
  // tslint:disable-next-line:component-selector
  //selector: 'body[root]',
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    ChatbotComponent,
    HeaderComponent,
    FooterComponent,
    RouterOutlet,
    SplashScreenComponent 
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  isIframe = false;
  loginDisplay = false;
  constructor(
   
    private splashScreenService: SplashScreenService,
    private router: Router,
    private modalService: NgbModal,
    private authService: MsalService,
    private toastr: ToastrService,
    private appConfigService: AppConfigService    
  ) {    
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
       
        // hide splash screen
         this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);

    if (!this.appConfigService.isProd()) {
      this.toastr.error("STOP - Do not apply any benefits on this website.", "TEST SYSTEM", {
        timeOut: 0,
        tapToDismiss: false
      });
    }
    this.setUpAnalytics();
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  setUpAnalytics() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        gtag('config', 'G-D8FW9K4D9Z',
          {
            page_path: event.urlAfterRedirects
          }
        );
      });
  }
}
